import type { StepT } from "@/components/common/Stepper";
import type { ToT } from "@/route-types";

export type CreateUserWizardStepKeyT = "details" | "organisations" | "access" | "billing" | "impersonate" | "templates";

export interface CreateUserWizardSearchT {
    userId?: string;
}

export function validateCreateUserWizardSearch(search: Record<string, unknown>): CreateUserWizardSearchT {
    const userId = typeof search.userId === "string" && search.userId.length > 0 ? search.userId : undefined;
    return { userId };
}

const STEP_ORDER: CreateUserWizardStepKeyT[] = [
    "details",
    "organisations",
    "access",
    "templates",
    "billing",
    "impersonate",
];

const STEP_LABELS: Record<CreateUserWizardStepKeyT, string> = {
    details: "Create user",
    organisations: "Assign organisations",
    access: "Assign access",
    templates: "Assign templates",
    billing: "Set billing",
    impersonate: "Sign in as user",
};

const STEP_ROUTES: Record<CreateUserWizardStepKeyT, ToT["to"]> = {
    details: "/users/create-user/details",
    organisations: "/users/create-user/organisations",
    access: "/users/create-user/access",
    billing: "/users/create-user/billing",
    impersonate: "/users/create-user/impersonate",
    templates: "/users/create-user/templates",
};

export function getCreateUserWizardSteps(current: CreateUserWizardStepKeyT, search: CreateUserWizardSearchT): StepT[] {
    const currentIndex = STEP_ORDER.indexOf(current);

    return STEP_ORDER.map((key, index) => {
        const stage = index === currentIndex ? "current" : index < currentIndex ? "past" : "future";
        const canNavigate = key === "details" || Boolean(search.userId);

        return {
            key,
            stage: canNavigate || stage === "current" ? stage : "future",
            words: STEP_LABELS[key],
            route: canNavigate
                ? {
                      to: STEP_ROUTES[key],
                      search: search.userId ? { userId: search.userId } : {},
                  }
                : undefined,
        };
    });
}
